import Phaser from 'phaser';
import { gameConfig } from './config/gameConfig';
import './style.css';

window.addEventListener('load', () => {
  new Phaser.Game(gameConfig);
});
